import { RadioButtonGroup } from 'browser/components/atomic-elements/atoms/radio-button/radio-button-group'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const RadioButtonGroupField = LabelFieldFactory({ InputComponent: RadioButtonGroup })
export { RadioButtonGroup, RadioButtonGroupField }
